import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { useEffect, useState } from 'react';
import { isMockMode } from 'utils/mock-mode';

export const useAgentName = () => {
  const [fullName, setFullName] = useState(isMockMode() ? 'Mock Agent' : '');

  useEffect(() => {
    if (isMockMode()) return;
    StandaloneAuth.client.getUser().then((user) => {
      const name = `${user?.given_name || ''} ${user?.family_name || ''}`;
      setFullName(name);
    });
  }, []);

  return { fullName };
};
